import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '../../../../../../environments/environment';

interface Tab {
  value: string;
  display: string;
}

@Component({
  selector: 'app-gallery-view-modal',
  imports: [CommonModule],
  templateUrl: './gallery-view-modal.component.html',
  styleUrl: './gallery-view-modal.component.scss'
})
export class GalleryViewModalComponent {
  assetUrl = environment.assetBaseUrl
  galleryImages: { src: string; }[] = [{ src: this.assetUrl + "img/salon-details1.png" }, { src: this.assetUrl + 'img/salon-details2.png' }, { src: this.assetUrl + 'img/salon-details3.png' }, { src: this.assetUrl + 'img/salon-details1.png' }, { src: this.assetUrl + "img/salon-details2.png" }, { src: this.assetUrl + 'img/salon-details3.png' }, { src: this.assetUrl + 'img/salon-details1.png' }, { src: this.assetUrl + 'img/salon-details2.png' }, { src: this.assetUrl + 'img/salon-details3.png' }, { src: this.assetUrl + 'img/salon-details1.png' }, { src: this.assetUrl + 'img/salon-details2.png' }]
  TabsArray: Tab[] = [{ value: 'photosBySalon', display: 'Photos by Salon' }, { value: 'photosByGuests', display: 'Photos by Guests' }]
  activeTab: string = "photosBySalon"
  activeImageIndx: number = 0;

  constructor() {
  }

  ngOnInit() {
  }

  onTabChange(tab: string): void {
    this.activeTab = tab;
    this.activeImageIndx = 0;
  }

  onImageChange(index: number): void {
    this.activeImageIndx = index;
  }

  nextImg() {
    this.activeImageIndx++
  }

  prevImg() {
    this.activeImageIndx--
  }
}
